import { __rest } from "tslib";
import { pipe } from 'fp-ts/function';
import { objectMap } from '../library/object';
export const fullMetalUiThemedSelector = '$fullMetalUi';
const dimension = ['none', '3xs', 'xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', '3xl', 'hugem', 'hugel', 'hugexl', 'hugexxl'];

const measureToString = v => typeof v.unit === 'undefined' ? `${v.value}` : `${v.value}${v.unit}`;

const isTokenMeasure = a => typeof a.value === 'number';

const isString = a => typeof a === 'string';

export const recursiveToString = ts => objectMap(ts, t => {
  if (isTokenMeasure(t)) {
    return measureToString(t);
  }

  if (isString(t)) {
    return t;
  }

  return recursiveToString(t);
});

const stringifyTokens = tokens => {
  const {
    space
  } = tokens,
        rts = __rest(tokens, ["space"]);

  return Object.assign(Object.assign({}, recursiveToString(rts)), {
    space: objectMap(space, s => measureToString({
      value: tokens.grid.value * s.value,
      unit: 'px'
    }))
  });
};

export function makeVanillaTokens(tokens) {
  return pipe(tokens, stringifyTokens);
}
export function makeFullMetalUiTheme(tokens, tokensClassName, head) {
  return {
    tokens,
    tokensClassName,
    head
  };
}
//# sourceMappingURL=makeFullMetalUiTheme.js.map